import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/ui/dialog";
import { Card, CardContent } from "components/ui/card_v3";
import { Button } from "components/ui/button_v2";
import { Sun, Moon, Globe } from "lucide-react";
import localization from "../../services/localization";

import { useUserStore } from "context/useUserStore";
import { useThemeStore } from "../../context/useThemeStore";
import { useLanguageStore } from "../../context/useLanguageStore";

import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

// import workerUrl from "/pdf.worker.min.mjs";

export default function WelcomeModal({ open, onClose }) {
  const { theme, setTheme } = useThemeStore();
  const { currentLang, setCurrentLang } = useLanguageStore();
  const [step, setStep] = useState(1);
  const [accepted, setAccepted] = useState(false);
  const { appUser, setAppUser } = useUserStore();

  // const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const handleFinish = () => {
    if (!accepted) return;
    onClose(accepted);
  };

  const select_bg = theme === "dark" ? "bg-[#121928] text-white" : "bg-white text-foreground";
  const select_bg2 = theme === "dark" ? " text-white" : "text-foreground";

  return (
    <Dialog open={open} onOpenChange={onClose} className={select_bg}>
      <DialogContent className={`${step === 3 ? "!max-w-6xl" : "!max-w-xl"} w-full ${select_bg}`}>
        <DialogHeader>
          <DialogTitle className={"text-center text-2xl font-bold " + select_bg2}>
            {localization.welcome_to_eduprompt || "Welcome to Eduprompt"}
          </DialogTitle>
        </DialogHeader>

        {/* Step Indicator */}
        <div className="flex justify-center gap-2 mt-2 text-sm text-muted-foreground">
          <span className={step === 1 ? "font-bold text-[var(--success-action-active)]" : ""}>
            1. {localization.language || "Language"}
          </span>
          <span>•</span>
          <span className={step === 2 ? "font-bold text-[var(--success-action-active)]" : ""}>
            2. {localization.theme || "Theme"}
          </span>
          <span>•</span>
          <span className={step === 3 ? "font-bold text-[var(--success-action-active)]" : ""}>
            3. {localization.privacy || "Privacy"}
          </span>
        </div>

        {/* Step Content */}
        <div className="mt-6">
          {/* STEP 1 */}
          {step === 1 && (
            <div className="flex gap-4 justify-center">
              <SelectCard
                icon={<Globe size={24} color="var(--primary-icon)" />}
                title={localization.english_ln || "English"}
                selected={currentLang === "En"}
                onClick={() => {
                  setCurrentLang("En");
                  localization.setLanguage("En");
                }}
              />
              <SelectCard
                icon={<Globe size={24} color="var(--primary-icon)" />}
                title={localization.italian_ln || "Italiano"}
                selected={currentLang === "It"}
                onClick={() => {
                  setCurrentLang("It");
                  localization.setLanguage("It");
                }}
              />
            </div>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <div className="flex gap-4 justify-center">
              <SelectCard
                icon={<Sun size={24} color="var(--primary-icon)" />}
                title={localization.light_mode || "Light Mode"}
                selected={theme === "light"}
                onClick={() => setTheme("light")}
              />
              <SelectCard
                icon={<Moon size={24} color="var(--primary-icon)" />}
                title={localization.dark_mode || "Dark Mode"}
                selected={theme === "dark"}
                onClick={() => setTheme("dark")}
              />
            </div>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <div className="space-y-4 text-sm">
              <div className="max-h-[60vh] overflow-y-auto border rounded-md p-0 text-muted-foreground">
                {/* <iframe
                  src={
                    appUser?.role === "administrative"
                      ? "/Admin.pdf"
                      : appUser?.role === "root"
                        ? "/Root.pdf"
                        : appUser?.role === "student"
                          ? "/Student.pdf"
                          : "/Teacher.pdf"
                  }
                  title="Privacy Policy"
                  className="w-full h-[520px]"
                /> */}
                <Worker workerUrl={"/pdf.worker.min.js"}>
                  <Viewer
                    fileUrl={
                      appUser?.role === "administrative"
                        ? "/Admin.pdf"
                        : appUser?.role === "root"
                          ? "/Root.pdf"
                          : appUser?.role === "student"
                            ? "/Student.pdf"
                            : "/Teacher.pdf"
                    }
                    // plugins={[defaultLayoutPluginInstance]}
                  />
                </Worker>
                {/* <p>
                  This platform processes your data according to our privacy
                  policy. Your information is securely stored and never shared
                  without consent. By continuing, you agree to our terms and
                  privacy policy.
                </p>
                <p className="mt-3">
                  This platform processes your data according to our privacy
                  policy. Your information is securely stored and never shared
                  without consent. By continuing, you agree to our terms and
                  privacy policy.
                </p>
                <p className="mt-3">
                  This platform processes your data according to our privacy
                  policy. Your information is securely stored and never shared
                  without consent. By continuing, you agree to our terms and
                  privacy policy.
                </p>
                <p className="mt-3">
                  This platform processes your data according to our privacy
                  policy. Your information is securely stored and never shared
                  without consent. By continuing, you agree to our terms and
                  privacy policy.
                </p>
                <p className="mt-3">
                  This platform processes your data according to our privacy
                  policy. Your information is securely stored and never shared
                  without consent. By continuing, you agree to our terms and
                  privacy policy.
                </p>
                <p className="mt-3">
                  This platform processes your data according to our privacy
                  policy. Your information is securely stored and never shared
                  without consent. By continuing, you agree to our terms and
                  privacy policy.
                </p>
                <p className="mt-3">
                  This platform processes your data according to our privacy
                  policy. Your information is securely stored and never shared
                  without consent. By continuing, you agree to our terms and
                  privacy policy.
                </p> */}
              </div>

              <div className="flex items-center gap-2 float-right">
                <input type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />
                <label>{localization.accept_privacy || "I have read and accept the privacy policy"}</label>
              </div>
            </div>
          )}
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-between mt-8">
          {step > 1 ? (
            <Button variant="outline" onClick={prevStep}>
              {localization.back || "Back"}
            </Button>
          ) : (
            <div />
          )}

          {step < 3 && (
            <Button
              className="action-btn success"
              onClick={nextStep}
              disabled={(step === 1 && !currentLang) || (step === 2 && !theme)}
            >
              {localization.next || "Next"}
            </Button>
          )}

          {step === 3 && (
            <Button className="action-btn success" onClick={handleFinish} disabled={!accepted}>
              {localization.finish || "Finish"}
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

function SelectCard({ icon, title, selected, onClick }) {
  return (
    <Card
      onClick={onClick}
      className={`
        w-40 cursor-pointer rounded-xl transition-all
        hover:scale-[1.03] hover:shadow-lg
        ${selected ? "border-primary ring-2 ring-primary" : ""}
      `}
    >
      <CardContent className="flex flex-col items-center text-center p-6 space-y-3">
        <div className="text-primary">{icon}</div>
        <h3 className="font-semibold">{title}</h3>
      </CardContent>
    </Card>
  );
}
